import React from 'react';
import { FormLabel, Slider, SliderTrack } from '@chakra-ui/react';
import { useField } from 'formik';
import { Rating } from 'components';
import { Control, MetaError } from './Control';

export const FormRating: React.FC<{ name: string; label?: string }> = ({
  name,
  label,
}) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [_, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const { value } = meta;

  return (
    <Control name={name} my={4}>
      {label && <FormLabel htmlFor={name}>{label}</FormLabel>}
      <Slider id={name} aria-label={name} onChange={setValue} max={5} step={1}>
        <Rating value={value}>
          <SliderTrack height={0} />
        </Rating>
      </Slider>
      <MetaError display="block" textAlign="center" name={name} />
    </Control>
  );
};

export { FormRating as Rating };
